import type { IconSvgObject } from './types';

const MoveTopIcon: IconSvgObject = [
  ["path", { d: "M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.0001 12L12.0001 2.41768M8.5 4.99998L12.0001 1.99998L15.5 4.99998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MoveTopIcon;
